<template lang='pug'>
    el-dialog.modal-upload-solicitacao-lote(
        :visible.sync='show',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        width='70%'
    )
        template(slot='title')
            div.modal-upload-solicitacao-lote__titulo {{ $t('mensagens.operacao.modalAlterarLote.titulo') }}

        section
            div.mb-2
                span.mr-2(style='color: red') *
                span.font-weight-bold {{ $t('mensagens.operacao.modalAlterarLote.labelTutorial') }}

            div.mb-4 {{ $t('mensagens.operacao.modalAlterarLote.texto1') }}
                |  {{ $t('mensagens.operacao.modalAlterarLote.texto2') }}
                | {{ $t('mensagens.operacao.modalAlterarLote.texto3') }}

            div.mb-2
                i.mdi.mdi-alert-circle.mr-2(style='color: #DDAC44; font-size: 16px')
                span.font-weight-bold  {{ $t('mensagens.operacao.atencao') }}

            div.mb-4 {{ $t('mensagens.operacao.modalTextoComum.texto1') }}
                |  {{ $t('mensagens.operacao.modalTextoComum.texto2') }}
                | {{ $t('mensagens.operacao.modalTextoComum.texto3') }}

        section
            el-upload(
                v-show='!arquivoSelecionado',
                action='#',
                :auto-upload='false'
                :on-change='selecionarArquivo',
                :on-exceed='onExceed',
                :limit='1',
                drag,
                ref='refUploadAlteracaoOperacaoEmLote'
            ).mb-2
                i.el-icon-upload
                .el-upload__text {{ $t('mensagens.operacao.textoUpload1') }} <em>{{ $t('mensagens.operacao.textoUpload2') }}</em>
            .arquivo-selecionado(v-if='arquivoSelecionado')
                .arquivo-selecionado__info
                    i.el-icon-document
                    span.arquivo-selecionado__nome {{ arquivoSelecionado.name }}
                    span.arquivo-selecionado__tamanho ({{ formatarTamanho(arquivoSelecionado.size) }})
                el-button.arquivo-selecionado__remover(type='text', icon='el-icon-close', @click='removerArquivo')
            span(v-else) {{ $t('mensagens.operacao.textoUpload3') }}

        template(slot='footer')
            div.d-flex.justify-content-between
                BaseButton(@click='fechar')
                    | {{ $t('mensagens.operacao.acoes.cancelar') }}
                BaseButton(type='primary', :disabled='!arquivoSelecionado', :loading='enviando', @click='enviarPlanilha')
                    | {{ $t('mensagens.operacao.acoes.confirmar') }}
</template>

<script>
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { TIPO_PLANILHA_OPERACAO } from '@/constants/tipoPlanilhaOperacao';

const ROTA_ALTERACAO_LOTE = '/operacao/alteracao-lote';

export default {
    name: 'ModalUploadAlteracaoOperacaoEmLote',
    components: {
        BaseButton
    },
    emits: ['atualizar'],
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            arquivoSelecionado: null,
            enviando: false
        };
    },

    methods: {
        selecionarArquivo(planilha) {
            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.ultrapassa15MB')
                });
                this.$refs.refUploadAlteracaoOperacaoEmLote.clearFiles();
                return;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx' && extension !== 'xls') {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.tipoNaoSuportado')
                });
                this.$refs.refUploadAlteracaoOperacaoEmLote.clearFiles();
                return;
            }

            this.arquivoSelecionado = planilha;
        },

        async enviarPlanilha() {
            if (!this.arquivoSelecionado) return;

            try {
                this.enviando = true;
                await OperacaoService.enviarPlanilhaOperacaoEmLote(
                    TIPO_PLANILHA_OPERACAO.ALTERACAO_OPERACOES,
                    this.arquivoSelecionado
                );

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.planilhaEnviadaValidacao')
                });

                this.fechar();
                this.$emit('atualizar');
                if (this.$route.path !== ROTA_ALTERACAO_LOTE) {
                    this.$router.push(ROTA_ALTERACAO_LOTE);
                }
            } catch (error) {
                this.$notify.error({
                    message: error?.response?.data?.message || this.$t('mensagens.operacao.notificacao.uploadErro')
                });
            } finally {
                this.enviando = false;
            }
        },

        onExceed() {
            this.$notify.warning({
                message: this.$t('mensagens.operacao.notificacao.uploadUnico'),
                position: 'top-left'
            });
        },

        limpar() {
            this.arquivoSelecionado = null;
            this.enviando = false;
            this.$refs.refUploadAlteracaoOperacaoEmLote.clearFiles();
        },

        fechar() {
            this.$emit('update:show', false);
            setTimeout(() => this.limpar(), 1000);
        },

        removerArquivo() {
            this.arquivoSelecionado = null;
            this.$refs.refUploadAlteracaoOperacaoEmLote.clearFiles();
        },

        formatarTamanho(bytes) {
            if (!bytes) return '0 B';
            const k = 1024;
            const unidades = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + unidades[i];
        }
    }
};
</script>

<style lang='scss'>
.modal-upload-solicitacao-lote {

    .modal-upload-solicitacao-lote__titulo {
        font-weight: bold;
        color: #00413C;
        font-size: 18px;
    }

    .el-dialog__body {
        padding: 20px !important;
        word-break: keep-all;
        word-wrap: break-word;
    }

    .el-dialog__header {
        padding-bottom: 20px !important;
        background: #E9E9E9;
    }

    .el-dialog__footer {
        padding-top: 20px !important;
        border-top: 1px solid #E9E9E9;
    }

    .arquivo-selecionado {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F0F9EB;
        border: 1px solid #E1F3D8;
        border-radius: 4px;
        padding: 10px 15px;
        margin-bottom: 8px;

        &__info {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #67C23A;

            i {
                font-size: 18px;
            }
        }

        &__nome {
            color: #303133;
            font-weight: 500;
        }

        &__tamanho {
            color: #909399;
            font-size: 12px;
        }

        &__remover {
            color: #F56C6C !important;
            padding: 0;
        }
    }

    .el-dialog {
        background: white !important;
    }
}
</style>
